import { Directive, inject } from '@angular/core';
import { NgForOf } from '@angular/common';

@Directive({
  selector: '[ngForTrackByIndex]',
  standalone: false,
})
export class NgForTrackByIndexDirective<T> {
  private ngFor = inject<NgForOf<T>>(NgForOf, { host: true });

  constructor() {
    this.ngFor.ngForTrackBy = (index: number, _item: T) => index;
  }
}
